import { Box } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import Paper from '@material-ui/core/Paper'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import NumberRow from 'components/number-porting/geographic-port/numbers-to-port/NumberRow'
import { GeographicPortContext } from 'contexts/GeographicPortContext'
import React, { useContext } from 'react'

const useStyles = makeStyles(theme => ({
  paper: {
    marginTop: theme.spacing(3),
    padding: theme.spacing(4),
  },
  formControl: {
    marginTop: theme.spacing(2),
    width: '100%',
  },
}))

function SingleNumberDDIs() {
  const classes = useStyles()
  const { state, dispatch } = useContext(GeographicPortContext)

  const handleAdd = () => {
    dispatch({ type: 'ADD_SINGLE_NUMBER_DDI' })
  }

  const handleUpdate = payload => {
    dispatch({ type: 'UPDATE_SINGLE_NUMBER_DDI', payload: payload })
  }

  const handleRemove = index => {
    dispatch({ type: 'REMOVE_SINGLE_NUMBER_DDI', payload: index })
  }

  return (
    <Paper className={classes.paper}>
      <Typography variant='h5' gutterBottom>
        Single Number DDIs
      </Typography>

      {state.number_details.single_number_ddis.map((x, index) => (
        <NumberRow
          key={`single-number-ddis-${index}`}
          index={index}
          stdCode={{ value: x.std_code.value }}
          stdCodeError={
            state.errors.hasOwnProperty(`single_number_ddis.${index}.std_code`)
              ? state.errors[`single_number_ddis.${index}.std_code`]
              : ''
          }
          localNumber={{ value: x.local_number.value }}
          localNumberError={
            state.errors.hasOwnProperty(`single_number_ddis.${index}.local_number`)
              ? state.errors[`single_number_ddis.${index}.local_number`]
              : ''
          }
          action={{ value: x.action.value }}
          isInService={{ value: x.is_in_service.value }}
          handleUpdate={handleUpdate}
          handleDelete={() => {
            handleRemove(index)
          }}
        />
      ))}

      <Box mt={3}>
        <Button variant='contained' color='primary' onClick={handleAdd}>
          Add
        </Button>
      </Box>
    </Paper>
  )
}

export default SingleNumberDDIs
